// extracted by mini-css-extract-plugin
module.exports = {"richText":"RichText_richText__GksMy","richTextCount":"RichText_richTextCount__AYvSn","c360":"RichText_c360__p9wDh"};